<template>
  <div
    :class="[
      'ra-banner',
      `ra-banner--${theme}`,
      `ra-banner--${displayMode}`,
      `ra-banner--${alignment}`,
    ]"
  >
    <component :is="view()" />
  </div>
</template>

<script>
import RefappBannerBaseSingle from './base/single.vue';
import RefappBannerBaseMultiple from './base/multiple.vue';

export default {
  name: 'refapp-banner',
  inject: ['displayMode', 'theme', 'alignment'],
  data(instance) {
    return {
      view() {
        switch (instance.displayMode) {
          case 'tile':
          case 'fullwidth':
            return RefappBannerBaseSingle;
          default:
            return RefappBannerBaseMultiple;
        }
      },
    };
  },
};
</script>

<style lang="scss">
@use '../styles/style.scss';
</style>
